import moment from 'moment';

export const formatWorkTimes = (workTimes) => Object.entries(workTimes)
  .reduce((acc, [key, value]) => {
    const [shortDayOfWeek, ...workTime] = value.split(':');
    const alwaysWorking = workTime[0].trim() === 'круглосуточно';
    if (alwaysWorking) {
      return { ...acc, [key]: { openTime: '00:00', closeTime: '23:59', shortDayOfWeek, alwaysWorking } }
    } else {
      const [openTime, closeTime] = workTime.join(':').trim().split('-');
      const closeTimeWithoutBreak = closeTime.split(',')[0];
      return { ...acc, [key]: { openTime, closeTime: closeTimeWithoutBreak, shortDayOfWeek, alwaysWorking } };
    }
  }, {});

export const isBetweenTime = (currentDayWorkingTimes, currentTzTime) => {
  const { openTime, closeTime, alwaysWorking } = currentDayWorkingTimes;
  if (alwaysWorking === true) return true;
  const format = 'hh:mm';
  const open = moment(openTime, format);
  const close = moment(closeTime, format);
  const currentTime = moment(currentTzTime, format);

  if (close.isBefore(open) === true) {
    const interval1 = currentTime.isBetween(open, moment('23:59', format));
    const interval2 = currentTime.isBetween(moment('00:00', format), close);
    return interval1 || interval2;
  } else {
    return currentTime.isBetween(open, close);
  }
};
